// import React, { useState } from "react";
// import Select from "react-select";
// import Styles from "../../assets/scss/HelpCenterNormalUser/HelpCenterAdmiForm.module.scss";
// import {
//   useGetEnquiryIssuesQuery,
//   useGetEnquiryUsersQuery,
//   useCreateEnquiryMutation,
// } from "../../slices/admin/admin";

// const HelpCenterAdmiForm = ({ onSuccess }) => {
//   /* ================= STATE ================= */
//   const [selectedUser, setSelectedUser] = useState(null);
//   const [modeOfContact, setModeOfContact] = useState("");
//   const [selectedIssue, setSelectedIssue] = useState(null);
//   const [comment, setComment] = useState("");
//   const [errors, setErrors] = useState({});


//   /* ================= API ================= */
//   const { data: issueData } = useGetEnquiryIssuesQuery();
//   const { data: userData } = useGetEnquiryUsersQuery();
//   const [createEnquiry, { isLoading }] = useCreateEnquiryMutation();

//   const issues = issueData?.data || [];
//   const users = userData?.data || [];

//   /* ================= USER OPTIONS ================= */
//   const userOptions = users.map((user) => ({
//     value: user._id,
//     label: `${user.firstName} ${user.lastName || ""} - ${user.phone || ""}`,
//   }));
//   const issueOptions = issues.map((issue) => ({
//     value: issue._id,
//     label: issue.issueName,
//   }));

//   /* ================= SUBMIT ================= */
//   const handleSubmit = async () => {
//     let newErrors = {};

//     if (!selectedUser) newErrors.user = "User is required";
//     if (!modeOfContact) newErrors.modeOfContact = "Mode of contact is required";
//     if (!selectedIssue)
//       newErrors.issueType = "Issue type is required";

//     setErrors(newErrors);

//     if (Object.keys(newErrors).length === 0) {
//       const payload = {
//         userId: selectedUser.value,
//         modeOfContact,
//         queries: [selectedIssue.label],
//         comments: comment,
//       };

//       try {
//         await createEnquiry(payload).unwrap();
//         if (onSuccess) onSuccess();

//         // Reset
//         setSelectedUser(null);
//         setModeOfContact("");
//         setSelectedIssue(null);
//         setComment("");
//         setErrors({});
//       } catch (error) {
//         console.error("Create enquiry failed:", error);
//       }
//     }
//   };

//   const selectStyles = {
//     control: (base) => ({
//       ...base,
//       minHeight: "50px",
//       height: "50px",
//       boxShadow: "none",
//       fontFamily: "'Poppins', sans-serif",
//     }),

//     valueContainer: (base) => ({
//       ...base,
//       height: "50px",
//       padding: "0 8px",
//       fontFamily: "'Poppins', sans-serif",
//     }),

//     singleValue: (base) => ({
//       ...base,
//       fontFamily: "'Poppins', sans-serif",
//     }),

//     placeholder: (base) => ({
//       ...base,
//       fontFamily: "'Poppins', sans-serif",
//     }),

//     menu: (base) => ({
//       ...base,
//       fontFamily: "'Poppins', sans-serif",
//     }),

//     menuPortal: (base) => ({
//       ...base,
//       zIndex: 9999,
//       fontFamily: "'Poppins', sans-serif",
//     }),
//   };

//   const handleCancel = () => {
//     setSelectedUser(null);
//     setModeOfContact("");
//     setSelectedIssue(null);
//     setComment("");
//     setErrors({});
//   };

//   return (
//     <div className={Styles.parent}>
//       <div className={Styles.box}>
//         <div className={Styles.popupForm}>
//           <div className={Styles.grid}>

//             {/* USER (SEARCHABLE) */}
//             <div className={Styles.inputGroup}>
//               <label className={Styles.inputLabel}>User *</label>

//               <Select
//                 options={userOptions}
//                 value={selectedUser}
//                 onChange={setSelectedUser}
//                 placeholder="Select User"
//                 classNamePrefix="select"
//                 styles={selectStyles}

//               />

//               {errors.user && (
//                 <span className={Styles.error}>{errors.user}</span>
//               )}
//             </div>


//             {/* ISSUE TYPE (SEARCHABLE) */}
//             <div className={Styles.inputGroup}>
//               <label className={Styles.inputLabel}>Issue Type *</label>

//               <Select
//                 options={issueOptions}
//                 value={selectedIssue}
//                 onChange={setSelectedIssue}
//                 placeholder="Select Issue Type"
//                 classNamePrefix="select"
//                 styles={selectStyles}

//               />

//               {errors.issueType && (
//                 <span className={Styles.error}>{errors.issueType}</span>
//               )}
//             </div>

//             {/* MODE OF CONTACT */}
//             <div className={Styles.inputGroup}>
//               <label className={Styles.inputLabel}>Mode of Contact *</label>
//               <select
//                 className={Styles.inputssss}
//                 value={modeOfContact}
//                 onChange={(e) => setModeOfContact(e.target.value)}
//               >
//                 <option value="">Select Mode</option>
//                 <option value="online">Online</option>
//                 <option value="phone">Phone</option>
//                 <option value="email">Email</option>
//               </select>

//               {errors.modeOfContact && (
//                 <span className={Styles.error}>{errors.modeOfContact}</span>
//               )}
//             </div>

//             {/* COMMENT */}
//             <div className={Styles.inputGroupFull}>
//               <label className={Styles.inputLabel}>Comment</label>
//               <textarea
//                 rows={3}
//                 className={Styles.input}
//                 placeholder="Enter comment (optional)"
//                 value={comment}
//                 onChange={(e) => setComment(e.target.value)}
//               />
//             </div>
//           </div>

//           {/* BUTTONS */}
//           <div className={Styles.footerButtons}>
//             <button className={Styles.cancel} onClick={handleCancel}>
//               Cancel
//             </button>
//             <button
//               className={Styles.save}
//               onClick={handleSubmit}
//               disabled={isLoading}
//             >
//               {isLoading ? "Saving..." : "Add"}
//             </button>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default HelpCenterAdmiForm;

import React, { useState } from "react";
import Select from "react-select";
import Styles from "../../assets/scss/HelpCenterNormalUser/HelpCenterAdmiForm.module.scss";
import {
  useGetEnquiryIssuesQuery,
  useGetEnquiryUsersQuery,
  useCreateEnquiryMutation,
} from "../../slices/admin/admin";

const HelpCenterAdmiForm = ({ onSuccess, onClose }) => {
  const [selectedUser, setSelectedUser] = useState(null);
  const [modeOfContact, setModeOfContact] = useState("");
  const [selectedIssue, setSelectedIssue] = useState(null);
  const [comment, setComment] = useState("");
  const [errors, setErrors] = useState({});

  const { data: issueData } = useGetEnquiryIssuesQuery();
  const { data: userData } = useGetEnquiryUsersQuery();
  const [createEnquiry, { isLoading }] = useCreateEnquiryMutation();

  const issues = issueData?.data || [];
  const users = userData?.data || [];

  const userOptions = users.map((user) => ({
    value: user._id,
    label: `${user.firstName} ${user.lastName || ""} - ${user.phone || ""}`,
  }));

  const issueOptions = issues.map((issue) => ({
    value: issue._id,
    label: issue.issueName,
  }));

  const handleSubmit = async () => {
    let newErrors = {};

    if (!selectedUser) newErrors.user = "User is required";
    if (!modeOfContact) newErrors.modeOfContact = "Mode of contact is required";
    if (!selectedIssue) newErrors.issueType = "Issue type is required";

    setErrors(newErrors);

    if (Object.keys(newErrors).length === 0) {
      const payload = {
        userId: selectedUser.value,
        modeOfContact,
        queries: [selectedIssue.label],
        comments: comment,
      };

      try {
        await createEnquiry(payload).unwrap();
        if (onSuccess) onSuccess();
        if (onClose) onClose();

        setSelectedUser(null);
        setModeOfContact("");
        setSelectedIssue(null);
        setComment("");
        setErrors({});
      } catch (error) {
        console.error(error);
      }
    }
  };

  const handleCancel = () => {
    setSelectedUser(null);
    setModeOfContact("");
    setSelectedIssue(null);
    setComment("");
    setErrors({});
    if (onClose) onClose();
  };

  const selectStyles = {
    control: (base) => ({
      ...base,
      minHeight: "45px",
      height: "45px",
      boxShadow: "none",
      borderColor: "#6d6d6d",
      "&:hover": { borderColor: "#548731" },
    }),
  };

  return (
    <div className={Styles.popupForm}>
      {/* HEADER SAME LIKE ADD ISSUE */}
      <div className={Styles.header}>
        <h2 className={Styles.tittle}>Create Ticket</h2>
        <span className={Styles.closeIcons} onClick={handleCancel}>
          X
        </span>
      </div>

      <div className={Styles.body}>

        <div className={Styles.inputGroup}>
          <label className={Styles.inputLabel}>User *</label>
          <Select
            options={userOptions}
            value={selectedUser}
            onChange={setSelectedUser}
            placeholder="Select User"
            styles={selectStyles}
          />
          {errors.user && (
            <span className={Styles.error}>{errors.user}</span>
          )}
        </div>

        <div className={Styles.inputGroup}>
          <label className={Styles.inputLabel}>Issue Type *</label>
          <Select
            options={issueOptions}
            value={selectedIssue}
            onChange={setSelectedIssue}
            placeholder="Select Issue Type"
            styles={selectStyles}
          />
          {errors.issueType && (
            <span className={Styles.error}>{errors.issueType}</span>
          )}
        </div>

        <div className={Styles.inputGroup}>
          <label className={Styles.inputLabel}>Mode of Contact *</label>
          <select
            className={Styles.inputssss}
            value={modeOfContact}
            onChange={(e) => setModeOfContact(e.target.value)}
          >
            <option value="">Select Mode</option>
            {/* <option value="online">Online</option> */}
            <option value="phone">Phone</option>
            <option value="email">Email</option>
          </select>
          {errors.modeOfContact && (
            <span className={Styles.error}>{errors.modeOfContact}</span>
          )}
        </div>

        <div className={Styles.inputGroup}>
          <label className={Styles.inputLabel}>Comment</label>
          <textarea
            rows={3}
            className={Styles.textarea}
            placeholder="Enter comment (optional)"
            value={comment}
            onChange={(e) => setComment(e.target.value)}
          />
        </div>

        <div className={Styles.footerButtons}>
          <button className={Styles.cancel} onClick={handleCancel}>
            Cancel
          </button>
          <button
            className={Styles.save}
            onClick={handleSubmit}
            disabled={isLoading}
          >
            {isLoading ? "Saving..." : "Add"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default HelpCenterAdmiForm;
